import axios from 'axios'
import {getServerApi} from '../../config/deployment'
import store from '../../vuex/store'
import { getAnyFirebaseToken } from '../../platform/auth/services/authService.js'

let envUri = getServerApi()
let uri = envUri+'/api/terms'

export const getTermsAndConditions = () => {
  return new Promise((resolve, reject) => {
    if(store.getters.termsAndConditions) resolve(store.getters.termsAndConditions)
    else {
      getAnyFirebaseToken()
        .then(res => {
          return axios.get(uri+'/general', {
            params: {
              token: res
            }
          })
          .then(resp => {
            if(resp.data.body) {
              store.commit("SET_TERMS_AND_CONDITIONS", resp.data.body)
              resolve(resp.data.body)
            }else reject("not found")
          })
          .catch(err =>{
            reject(err)
          })
        })
    }

  })
}

export const getAccomodationTerms = () => {
  return new Promise((resolve, reject) => {
    if (store.getters.dealInView.accomodationTerms) {
        resolve(store.getters.dealInView.accomodationTerms);
        return;
    }
    if(store.getters.accomodationTerms) resolve(store.getters.accomodationTerms)
    else {
      getAnyFirebaseToken()
        .then(res => {
          return axios.get(uri+'/accomodationAgreement', {
            params: {
              token: res
            }
          })
          .then(resp => {
            if(resp.data.body) {
              store.commit("SET_ACCOMODATION_TERMS", resp.data.body)
              resolve(resp.data.body)
            }else reject("not found")
          })
          .catch(err =>{
            reject(err)
          })
        })
    }

  })
}



// WEBPACK FOOTER //
// ./src/terms/repository/termsRepository.js